import React, { useEffect, useState } from "react";
import "./style/geostyle.css";
import axios from "axios";

// Define Language interface with 'value' instead of 'code'
interface Language {
  value: string;
  name: string;
}

interface TargetingData {
  geo: string; // Comma-separated string of language values
  name: string;
  code: string;
}

interface StepProps {
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  formData: {
    geo: string;
    name: string;
    code: string;
    [key: string]: string;
  };
  recordId: number;
  handleClose: () => void; // Close the popup
  onUpdate: () => void;  // Callback to refresh the data after update
}

const LanguageTargetingPopup: React.FC<StepProps> = ({ handleInputChange, formData, recordId, handleClose, onUpdate }) => {
  // Hardcoded list of languages from your provided JSON
  const languagesData = [
    {"value": "1", "name": "Afrikaans"},
    {"value": "2", "name": "Albanian"},
    {"value": "123", "name": "Arabic"},
    {"value": "7", "name": "Arabic (Algeria)"},
    {"value": "17", "name": "Arabic (Bahrain)"},
    {"value": "5", "name": "Arabic (Egypt)"},
    {"value": "4", "name": "Arabic (Iraq)"},
    {"value": "13", "name": "Arabic (Jordan)"},
    {"value": "15", "name": "Arabic (Kuwait)"},
    {"value": "14", "name": "Arabic (Lebanon)"},
    {"value": "6", "name": "Arabic (Libya)"},
    {"value": "8", "name": "Arabic (Morocco)"},
    {"value": "10", "name": "Arabic (Oman)"},
    {"value": "18", "name": "Arabic (Qatar)"},
    {"value": "3", "name": "Arabic (Saudi Arabia)"},
    {"value": "12", "name": "Arabic (Syria)"},
    {"value": "9", "name": "Arabic (Tunisia)"},
    {"value": "16", "name": "Arabic (U.A.E.)"},
    {"value": "11", "name": "Arabic (Yemen)"},
    {"value": "19", "name": "Basque"},
    {"value": "21", "name": "Belarusian"},
    {"value": "20", "name": "Bulgarian"},
    {"value": "22", "name": "Catalan"},
    {"value": "124", "name": "Chinese"},
    {"value": "25", "name": "Chinese (Hong Kong SAR)"},
    {"value": "24", "name": "Chinese (PRC)"},
    {"value": "26", "name": "Chinese (Singapore)"},
    {"value": "23", "name": "Chinese (Taiwan)"},
    {"value": "27", "name": "Croatian"},
    {"value": "28", "name": "Czech"},
    {"value": "29", "name": "Danish"},
    {"value": "30", "name": "Dutch"},
    {"value": "31", "name": "Dutch (Belgium)"},
    {"value": "32", "name": "English"},
    {"value": "35", "name": "English (Australia)"},
    {"value": "41", "name": "English (Belize)"},
    {"value": "36", "name": "English (Canada)"},
    {"value": "38", "name": "English (Ireland)"},
    {"value": "40", "name": "English (Jamaica)"},
    {"value": "37", "name": "English (New Zealand)"},
    {"value": "39", "name": "English (South Africa)"},
    {"value": "42", "name": "English (Trinidad)"},
    {"value": "34", "name": "English (United Kingdom)"},
    {"value": "33", "name": "English (United States)"},
    {"value": "43", "name": "Estonian"},
    {"value": "44", "name": "Faeroese"},
    {"value": "45", "name": "Farsi"},
    {"value": "46", "name": "Finnish"},
    {"value": "47", "name": "French"},
    {"value": "48", "name": "French (Belgium)"},
    {"value": "49", "name": "French (Canada)"},
    {"value": "51", "name": "French (Luxembourg)"},
    {"value": "50", "name": "French (Switzerland)"},
    {"value": "52", "name": "Gaelic (Scotland)"},
    {"value": "54", "name": "German"},
    {"value": "56", "name": "German (Austria)"},
    {"value": "58", "name": "German (Liechtenstein)"},
    {"value": "57", "name": "German (Luxembourg)"},
    {"value": "55", "name": "German (Switzerland)"},
    {"value": "59", "name": "Greek"},
    {"value": "60", "name": "Hebrew"},
    {"value": "61", "name": "Hindi"},
    {"value": "62", "name": "Hungarian"},
    {"value": "63", "name": "Icelandic"},
    {"value": "64", "name": "Indonesian"},
    {"value": "53", "name": "Irish"},
    {"value": "65", "name": "Italian"},
    {"value": "66", "name": "Italian (Switzerland)"},
    {"value": "67", "name": "Japanese"},
    {"value": "68", "name": "Korean"},
    {"value": "69", "name": "Korean (South Korea)"},
    {"value": "70", "name": "Latvian"},
    {"value": "71", "name": "Lithuanian"},
    {"value": "72", "name": "Macedonian (FYROM)"},
    {"value": "73", "name": "Malaysian"},
    {"value": "74", "name": "Maltese"},
    {"value": "75", "name": "Norwegian (Bokmal)"},
    {"value": "76", "name": "Polish"},
    {"value": "78", "name": "Portuguese"},
    {"value": "77", "name": "Portuguese (Brazil)"},
    {"value": "79", "name": "Rhaeto-Romanic"},
    {"value": "80", "name": "Romanian"},
    {"value": "81", "name": "Romanian (Republic of Moldova)"},
    {"value": "82", "name": "Russian"},
    {"value": "83", "name": "Russian (Republic of Moldova)"},
    {"value": "84", "name": "Sami (Lappish)"},
    {"value": "85", "name": "Serbian"},
    {"value": "86", "name": "Slovak"},
    {"value": "87", "name": "Slovenian"},
    {"value": "88", "name": "Sorbian"},
    {"value": "89", "name": "Spanish"},
    {"value": "98", "name": "Spanish (Argentina)"},
    {"value": "103", "name": "Spanish (Bolivia)"},
    {"value": "100", "name": "Spanish (Chile)"},
    {"value": "96", "name": "Spanish (Colombia)"},
    {"value": "92", "name": "Spanish (Costa Rica)"},
    {"value": "94", "name": "Spanish (Dominican Republic)"},
    {"value": "99", "name": "Spanish (Ecuador)"},
    {"value": "104", "name": "Spanish (El Salvador)"},
    {"value": "91", "name": "Spanish (Guatemala)"},
    {"value": "105", "name": "Spanish (Honduras)"},
    {"value": "90", "name": "Spanish (Mexico)"},
    {"value": "106", "name": "Spanish (Nicaragua)"},
    {"value": "93", "name": "Spanish (Panama)"},
    {"value": "102", "name": "Spanish (Paraguay)"},
    {"value": "97", "name": "Spanish (Peru)"},
    {"value": "107", "name": "Spanish (Puerto Rico)"},
    {"value": "101", "name": "Spanish (Uruguay)"},
    {"value": "95", "name": "Spanish (Venezuela)"},
    {"value": "108", "name": "Sutu"},
    {"value": "109", "name": "Swedish"},
    {"value": "110", "name": "Swedish (Finland)"},
    {"value": "111", "name": "Thai"},
    {"value": "112", "name": "Tsonga"},
    {"value": "113", "name": "Tswana"},
    {"value": "114", "name": "Turkish"},
    {"value": "115", "name": "Ukrainian"},
    {"value": "116", "name": "Urdu"},
    {"value": "117", "name": "Venda"},
    {"value": "118", "name": "Vietnamese"},
    {"value": "119", "name": "Vietnamese (Vietnam)"},
    {"value": "120", "name": "Xhosa"},
    {"value": "121", "name": "Yiddish"},
    {"value": "122", "name": "Zulu"}
  ];

  const [availableLanguages, setAvailableLanguages] = useState<Language[]>(languagesData);
  const [selectedLanguages, setSelectedLanguages] = useState<Language[]>([]);

  // Log to check availableLanguages and selectedLanguages
  console.log("Available Languages:", availableLanguages);

  // Fetch specific data for this recordId
  useEffect(() => {
    const fetchTargetingData = async () => {
      try {
        const recordResponse = await axios.get<TargetingData>(`https://bidvertiser-api.vercel.app/api/targeting/geo/${recordId}`);
        const { geo } = recordResponse.data;

        // Populate selected languages from the fetched data
        const selectedLanguageValues = geo.split(","); // Assuming geo is stored as a comma-separated string of language values
        const selectedLanguageList = languagesData.filter((lang) => selectedLanguageValues.includes(lang.value));
        setSelectedLanguages(selectedLanguageList);

        // Update formData
        handleInputChange({
          target: {
            name: "geo",
            value: geo,
          },
        } as React.ChangeEvent<HTMLInputElement>);
      } catch (error) {
        console.error("Error fetching language data:", error);
      }
    };

    fetchTargetingData();
  }, [recordId, handleInputChange]);

  // Handle double-click on language to add/remove it from selectedLanguages
  const handleDoubleClick = (language: Language) => {
    if (selectedLanguages.some((item) => item.value === language.value)) {
      setSelectedLanguages((prev) => prev.filter((item) => item.value !== language.value));
      setAvailableLanguages((prev) => [...prev, language]);
    } else {
      setAvailableLanguages((prev) => prev.filter((item) => item.value !== language.value));
      setSelectedLanguages((prev) => [...prev, language]);
    }
  };

  // Update the geo field whenever selectedLanguages changes
  useEffect(() => {
    const languageValues = selectedLanguages.map((lang) => lang.value).join(",");
    handleInputChange({
      target: {
        name: "geo",
        value: languageValues,
      },
    } as React.ChangeEvent<HTMLInputElement>);
  }, [selectedLanguages, handleInputChange]);

  const handleUpdate = async () => {
    const updatedGeo = selectedLanguages.map((lang) => lang.value).join(",");

    try {
      await axios.put(`hhttps://bidvertiser-api.vercel.app/api/targeting/updateTargeting/${recordId}`, { geo: updatedGeo });
      alert("Language Targeting updated successfully!");
      onUpdate();  // Call the parent callback to refresh the data
      handleClose();  // Close the popup
    } catch (error) {
      console.error("Error updating Language Targeting:", error);
    }
  };

  return (
    <div className="MainGeo">
      <h1 className="Geoheading">Language Targeting</h1>
      <p>
        BidVertiser allows you to display your ads according to the user's browser supported languages.
        <br />
        Select your desired languages and click <b>"Update"</b> and we will show your ads only to users using the languages you've selected.
      </p>

      <div>
        <h1 className="Geoheading">Languages Targeting</h1>

        <div style={{ display: "flex", justifyContent: "left", gap: "20px", marginTop: "20px" }}>
          {/* Available Languages */}
          <div style={{ width: "300px", fontSize: "12px" }}>
            <h3 className="Geoheading">Available Languages</h3>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                border: "1px solid #ccc",
                height: "500px",
                overflowY: "scroll",
              }}
            >
              {languagesData.length > 0 ? (
                languagesData.map((language) => (
                  <li
                    key={language.value}
                    style={{
                      padding: "2px 5px",
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                    }}
                    onDoubleClick={() => handleDoubleClick(language)}
                  >
                    <span style={{ textTransform: "uppercase" }}>{language.name}</span>
                  </li>
                ))
              ) : (
                <li>No languages available</li>
              )}
            </ul>
          </div>

          {/* Selected Languages */}
          <div style={{ width: "300px", fontSize: "12px" }}>
            <h3 className="Geoheading">Selected Languages</h3>
            <ul
              style={{
                listStyle: "none",
                padding: "2px 5px",
                border: "1px solid #ccc",
                height: "500px",
                overflowY: "scroll",
              }}
            >
              {selectedLanguages.length > 0 ? (
                selectedLanguages.map((language) => (
                  <li
                    key={language.value}
                    style={{
                      padding: "0px",
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                    }}
                    onDoubleClick={() => handleDoubleClick(language)}
                  >
                    <span style={{ textTransform: "uppercase" }}>{language.name}</span>
                  </li>
                ))
              ) : (
                <li>No languages selected</li>
              )}
            </ul>
          </div>
        </div>

        <button
          style={{ padding: "10px", backgroundColor: "#1A3F66", color: "white", borderRadius: "2px", marginTop: "20px" }}
          onClick={handleUpdate}
        >
          Update
        </button>
      </div>
    </div>
  );
};

export default LanguageTargetingPopup;
